/**
 * Password Strength Indicator Component
 * 4-segment strength bar with color coding per design guidelines
 */
import React from 'react';
import { calculatePasswordStrength, getPasswordStrengthText } from '../../utils/validation';

interface PasswordStrengthIndicatorProps {
  password: string;
}

export const PasswordStrengthIndicator = ({ password }: PasswordStrengthIndicatorProps) => {
  const strength = calculatePasswordStrength(password);

  if (!password) return null;

  return (
    <div className="mt-2" data-testid="password-strength-indicator">
      <div className="flex gap-1 mb-1">
        <div
          className={`h-1 flex-1 rounded transition-colors duration-200 ${
            strength >= 1 ? 'bg-red-500' : 'bg-slate-200'
          }`}
          data-testid="strength-bar-1"
        />
        <div
          className={`h-1 flex-1 rounded transition-colors duration-200 ${
            strength >= 2 ? 'bg-amber-500' : 'bg-slate-200'
          }`}
          data-testid="strength-bar-2"
        />
        <div
          className={`h-1 flex-1 rounded transition-colors duration-200 ${
            strength >= 3 ? 'bg-emerald-500' : 'bg-slate-200'
          }`}
          data-testid="strength-bar-3"
        />
        <div
          className={`h-1 flex-1 rounded transition-colors duration-200 ${
            strength >= 4 ? 'bg-emerald-600' : 'bg-slate-200'
          }`}
          data-testid="strength-bar-4"
        />
      </div>
      <p className="text-xs text-slate-500" data-testid="strength-text">
        {getPasswordStrengthText(strength)}
      </p>
    </div>
  );
};
